<section
  class="xl:h-[620px] py-8 bg-primary-100 bg-cover bg-[url('/assets/img/theme-bg.webp')]"
>
  <div class="flex flex-col items-center justify-center h-full drop-shadow-md">
    <img
      class="w-full max-w-screen-sm xl:max-w-2xl"
      src="../../../../assets/img/hero.png"
    />
    <h1 class="text-[2.625rem] text-white font-bold" i18n>SKILLZ</h1>
    <span class="text-xl mt-1 mb-5 text-white" i18n>#wehaveskillz</span>
    <div class="w-full px-4 flex justify-center">
      <form
        (ngSubmit)="onSubmit()"
        class="w-full grid p-3 pb-8 xl:pb-3 gap-3 items-center rounded-md bg-white max-w-screen-sm xl:grid-cols-6 xl:max-w-6xl relative"
      >
        <app-course-catalogue-location-filter></app-course-catalogue-location-filter>
        <app-course-catalogue-period-filter></app-course-catalogue-period-filter>
        <app-course-catalogue-age-filter></app-course-catalogue-age-filter>
        <app-course-catalogue-theme-category-filter></app-course-catalogue-theme-category-filter>
        <app-course-catalogue-theme-filter></app-course-catalogue-theme-filter>
        <button class="button h-full" data-cy="search-submit" i18n>
          View our range!
        </button>
      </form>
    </div>
  </div>
</section>
